module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "AB _idGenParaOverride-1"
  }, [_vm._v("Paul was born in Canberra in 1983, and following high school, enrolled at the Australian National University from which he graduated with a Bachelor of Arts, Graduate Diploma in Arts, Master of Translation. In 2009, Paul was diagnosed with Asperger’s Syndrome (Autism) on the high end of the spectrum and learned Acceptance and Commitment Therapy from an octogenarian former psychology professor. He devotes his time to assisting young people on the spectrum by writing on the subject and coaching on an individual basis. He also works in his mother’s legal practice where he is responsible for updating, reviewing, and maintaining the legal precedents library.")]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy ParaOverride-1"
  }, [_vm._v("Copyright © Paul Jordan 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The right of ")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Paul Jordan")]), _c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ISBN 9781035831449 (Paperback)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ISBN 9781035831456 (ePub e-book)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("www.austinmacauley.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("First Published 2024")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Austin Macauley Publishers Ltd®")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("1 Canada Square ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Canary Wharf ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('p', {
    staticClass: "AB _idGenParaOverride-1"
  }, [_vm._v("My thanks are extended to my parents and brother, David, who have always provided the support needed to pursue my interest in writing. Thanks are also due to my teacher, Professor Anna Wierzbicka, who invented Natural Semantic Metalanguage to assist young persons on the autism spectrum and which features in the stories.")]), _vm._v(" "), _c('p', {
    staticClass: "preface ParaOverride-5"
  }, [_vm._v("Book Preface")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This is a collection of stories intended for 9 to 13-year-old children. These stories are narrated by various species of animals about their habitats and lives. These stories all have a lesson or moral and aim to teach something about a linguistic tool that I studied at university.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This tool is called the Natural Semantic Metalanguage or NSM. It was invented and developed in 1972 by my former professor, Emerita Professor Anna Wierzbicka of the Australian National University. The NSM has been researched and developed since then with applications such as translation and science communication.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The NSM is a linguistic tool using the 65 simplest words (called semantic primes or primitives) in all languages, which can all be learned from the age of nine and don’t belong to any particular culture. The primes, and their combinations in sentences, are translatable in all languages (called canonical sentences).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The simple words are also part of more complicated words called semantic molecules and are marked with an M in brackets like this: (M). There are also universal keywords which are useful in all languages and cultures. For the benefit of the reader, I will put the semantic primes in bold. However, the pronouns I, you, and me (the objective form of I and called an allolex as it is a counterpart of I) are also semantic primes although are so obviously frequent that I will not put them in bold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Barafa the Snow Leopard:")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello. I’m Barafa, a male snow leopard. My name means ‘snow’ in the Punjabi language (M). You children (M) reading ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" may have ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("some idea")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of how we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live. Maybe")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("are")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" less well known than ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("some")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of the ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" cats.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("There were also issues with ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("many")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of us being shot for our fur (M) pelts, our bones (M) for medication and in ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("some")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" cases, our flesh. However, due to conservation efforts, making of fake fur (M), and breeding in zoos, otherwise ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("known")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" as captive breeding, there are ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("more")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of us leopards, although at ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" stage there may ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" around (M) 10000 of us from China to southwest Asia, in the former Soviet republics.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" in the Himalayan mountains on the borders of India, Tibet, and Nepal. I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" grey fur (M), black (M) and white (M) ears (M) and am about ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("two")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" metres long (M). My tail (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" over a metre long (M). It helps me balance, contains ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("body")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" fat and is covered in fur (M). ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" we leopards are asleep, we use it ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("a blanket to cover our exposed faces (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("In summer (M), we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" at an elevation of 2700 m to 6000 m – ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("above")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the trees. In winter (M), we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" at a lower altitude of 1200 m to 2000 m. As our name suggests, we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" walk in snow yet also")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("in rocky areas. An adult (M) snow leopard hunts by jumping down a slope and eating (M) a Himalayan blue (M) sheep. These sheep are most of our diet. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" you children (M) imagine eating (M) only every ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("two")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" weeks (M)?")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt9.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("There may "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("be")]), _vm._v(" food (M) you don’t especially "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("like")]), _vm._v(" eating (M) – so you "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("think")]), _vm._v(" you may only "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("want")]), _vm._v(" to eat (M) every "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("two")]), _vm._v(" weeks (M). I "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("think")]), _vm._v(" we snow leopards (M) "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("live")]), _vm._v(" a "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("few")]), _vm._v(" years (M) longer than domestic cats.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The first year (M) of a cat’s life is fifteen human (M) years (M), the second year (M) nine human (M) years (M), and every year (M) thereafter four human (M) years (M). We ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to 21. That is precisely 100 human (M) years (M) – so we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" long (M) lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("On average three cubs are born (M), drinking (M) their mother’s (M) milk (M) for ten weeks (M) and starting to walk halfway through that period. An eight-year-old snow leopard")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" usually have their own cubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We are nocturnal. We are awake from afternoon (M) to early morning (M) so you might say we are semi-diurnal. Diurnal refers to an animal (M) being active during daylight hours. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Here")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" is a story about ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("something")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("happened ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("to my pack, my mate and I.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As I said, I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" in the Himalayas with my mate, Ratna, and our three cubs, Sanjeev, Sushila, and Pranab. The researchers who came to study and track us were Indians.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hence, we all have Indian names. Ratna is such a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("good")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" leopardess and I love (M) her a lot. I am now nine years (M) old (M) and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" known (M) Ratna for the last four years (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have lived")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" our whole lives in the Himalayas and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("of the adaptations such as our thick coats, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" wide (M) paws (M) with a lot of surface (M) area and our ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("good")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" eyesight that most ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("if not all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" felines (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" we are equipped to live in the mountains.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Your domestic cats, of course, could ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" in ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("environment. They may ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the agility; however, they live with humans (M) and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("are")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" looked ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" so will ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" used to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" harsh environment.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Similarly, I would ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" manage in a zoo, and I prefer to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" in ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" environment. So ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Ratna and the cubs. However, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of my female (M) cousins (M) was taken to a zoo in the United States to participate in a captive breeding program. While ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" is ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("good")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" for snow leopards and our species, it was a loss for our family ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" you win ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("some,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" you lose ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("some.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the three cubs Sanjeev, Sushila, and Pranab were born (M) they weighed between 320 g and 600 g. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" interacted with humans (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("before")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" and somehow ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know maybe")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" from seeing them, that some human (M) babies ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("if")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" they are prematurely born (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" weigh just 600g.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The same")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" weight as ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of my cubs! These human (M) babies are comparable to a cub so therefore I would consider them as furless cubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I’m, of course, a wild animal (M), yet interacting with human (M) researchers has caused me to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" sensitive to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("small")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" humans (M). Given an opportunity, I’m sure Ratna and I would be very protective of the vulnerable little humans (M) and would never hurt them. We would keep them warm, and stroke them, although human (M) milk (M) is different to feline milk (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ours seems to be richer because of the different needs of a big wild cat in a harsh mountainous environment of course. I would be very caring to one of the small humans (M), and I hope men (M) and women (M) will trust us to interact safely with them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You children (M) reading ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this may")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" know that domestic pets, especially puppies and kittens are born (M) blind, as well as deaf. They ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("are not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" born (M) blind due to disability.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" most humans (M) are born (M) being able to see. The reason such animals (M) as puppies and are born (M) blind is ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" their eyelids (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("are not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" developed enough and the optic nerves (M) – the nerves (M) controlling eyesight – ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("also ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" fully developed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("They ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("don’t")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" work properly until seven to ten days (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the animal (M) is born (M). ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" a week (M), therefore, the animal’s (M) eyes (M) open and they see properly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Our three cubs lay around (M) and drank (M) Ratna’s milk (M) for several weeks (M), about five weeks (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" up. I protected Ratna while she fed the three cubs (M). We ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("don’t have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" any predators in the Himalayas; however, we still need to eat (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As I mentioned, we mainly eat (M) the Himalayan blue (M) sheep We’ll each eat (M) a sheep, tearing it apart and eating (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("every")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" two")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" weeks (M). ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" eating (M) a sheep or ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("sometimes ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("a wild pig, we don’t need anything for another two weeks (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sanjeev, Pranab, and Sushila ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("are good")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" cubs and they all stopped needing to drink (M) their mother’s (M) milk (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("ten weeks (M) of age. Ratna and I taught them to hunt, and we all shared a sheep together. Ratna and I were very proud of our cubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("They ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" played in the snow and displayed a lot of energy and good hunting skills. When the cubs were four months of age, they left the den, however they always stayed close to us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("There were, however, some challenges or problems. When Sushila was six years (M) old (M), that is, the equivalent to a 40-year (M) old (M) human (M), she was sent to a zoo in Canada for captive breeding. I had to accept my daughter (M) going away for the benefit of our entire species.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sadly, also a horrible poacher tried to shoot and kill Ratna for her fur (M), skeleton, and flesh. She escaped this. As you humans (M) say, she dodged a bullet, and I was delighted she survived. I ran at the poacher, knocked the rifle (M) out of his hands (M) and bit into his upper arm (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Yes, he lost blood (M) and had to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" taken to hospital to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the bite treated by disinfection and stitching. The horrible man (M) was not to threaten my family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I’m grateful for my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt14.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head ParaOverride-5"
  }, [_vm._v("Bianca the Jaguar –")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello, my name is Bianca and I’m a jaguar who lives in Brazil. Specifically, in the huge Amazon rainforest, which you no doubt ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" heard of. Brazil is the biggest country in South America and the fifth largest country in the world (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("A lot of you children (M) reading ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" will likely ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" an interest in geography, so therefore, you should have some idea ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("where I live.")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" You children (M) may also ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that a luxury car (M) manufactured in England was named ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Bianca, of course, but Jaguar. Presumably ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the car has ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("things")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" in common with me – power and speed. I am the only ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" cat in South America. There are no other big cats who ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" in South America except us jaguars and as you would know, I am a predator, a meat eater.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You children (M) who own ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("small")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" domestic cats would ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("think ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("they are gentle. However, those of us ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" cats who must hunt to survive, can be aggressive. However, I know of some intelligent and very rich men (M) who own and operate zoos. They sometimes allow human (M) visitors to pay to feed and carefully pat big cats who are looked ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" by zookeepers who went to university. I have heard of other jaguars having contact with humans (M), although I have not interacted with them myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Jaguars and leopards look similar. However, there is one way to tell the difference. Leopards and jaguars both have yellowish fur (M) with black (M) rosettes, although the jaguar’s rosettes have black (M) spots or dots in the middle of (M) them. We are smaller than other big cats, yet still strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We jaguars live throughout the Americas – from Arizona and New Mexico in the southwestern United States, through Mexico and Central America, to Colombia, Ecuador, Brazil, Paraguay, Bolivia, and Argentina in South America. We jaguars live in places such as forests, rainforests, deserts, and savannah.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Each jaguar has their own territory which is from 5km")]), _c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to 13km")]), _c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(". The small number (M) 2 means squared, so each jaguar’s territory is from five to thirteen square kilometres.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Most of our diet is meat and fish. We eat (M) peccaries, which are a kind of smaller pig-like animal (M), who are from the same family as the pig. We also eat (M) tapirs which are hoofed mammals (M) that look like pigs, often having black (M) and white (M) fur (M) and are related to the horse.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We also eat (M) capybaras (which are the world’s (M) largest rodent (M) – and the native people also eat (M) them). If I kill a mammal (M), I may have to drag it into the fork of a tree while the cubs and I eat (M) it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I can also catch fish by diving into and swimming in the river. The four cubs are born (M) after 95-105 days (M) in a den on the riverbank or in rocks and the father (M) is not involved. I need to always protect the cubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So, I will tell you a story which teaches a lesson. I’ll tell you about when I learned to hunt. I grew up in a pack of two sisters (M) and a brother (M) near the river and quickly learned to hunt in a tough environment, a place with so much life packed into a great big area that it was a competition to survive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Also, I must accept that in our species the father (M) does not help raise the cubs, leaving the mother (M) to do so. With us, the situation is different from other big cats where the father (M) helps to raise the cubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Our situation is all that I am familiar with because I know that I was born (M) a jaguar, and not another species of big cat. I spent a lot of time in my early cubhood playing with my brothers (M) and sisters (M) and watching our mother (M) hunt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She would jump out of trees, as jaguars do, and grab a passing tapir from the ground (M) or an alligator or caiman that was swimming past, grab it by its neck (M), and bite into its neck (M) to bleed it dry (M). After the prey had died (M), mother (M) would eat (M) of it first and then all the cubs (M) would eat (M) of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This is how I learned to hunt; Jaguars are 1.7 to 2.7 m long (M), 70 to 75cm tall at the shoulder (M), and the colour (M) of our fur varies from yellow to russet (red brown), maybe depending on where our range is, where we live.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Growing (M) up, I helped my mother (M) to hunt, and I looked after the other cubs. Jaguars live about as long (M) as your domestic cats. We live 12 to 16 years (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I’m not sure if you remember this, although the first year (M) of a cat’s life is equal to fifteen years (M), the second to nine years (M) and every year (M) thereafter to four years.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Therefore, in human (M) terms, we live from 64 to 80 years (M). I think we have a harder (M) life than your average domestic cat (M) does! We’re frequently moving and having to use a lot more energy than cats who are looked after by humans (M) do. There are many threats to the Amazon jaguars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When I was two years (M) old (M), equal to a seventeen-year (M) old (M) girl (M) (some of you children (M) might have big sisters (M) that age so you know what they can be like), I left my siblings (M) and my mother’s (M) den.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It was a rite of passage, and some years (M) later, I found a mate and had four cubs (M) by him. Raising the cubs was not easy, as I found out. I had to protect them from our main predators.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One of the world’s (M) largest snakes, the anaconda, which is a constrictor, has sometimes squeezed jaguars to death so it can eat (M) them. All we can do is outrun them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Some of the native people also eat (M) the jaguar (M), so we must also outrun them. It’s not an easy life, although you children (M) reading this should realise that you must work hard (M) and look after others. I was hunting a peccary when something unfortunate happened.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("An anaconda nearly squeezed one of my cubs before I pulled him out of the way, and he survived the attack. I know the anaconda must eat (M) although he will not attack one of my cubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The other serious threat to our habitat is, as a lot of you children (M) realise, deforestation. When trees are burned or cut down, the soil flows into the river, affecting it, and the rainforest heats up. We can’t live in an environment like this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am pleased to find out that some local humans (M) have used what they call drones to plant seeds in the ground (M) as well as planting them over a large area so that trees will regrow (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We know, and you children (M) reading this know, that the animals (M) jaguars eat (M) or prey on need to also have enough to eat (M). There are also protected areas of forest, and I hope that the stewardship of the forest continues. For the sake of all who live in it, it must continue!")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt20.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head ParaOverride-5"
  }, [_vm._v("Cyan the Blue Whale –")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello. My name is Cyan. If you know that cyan is a name for a shade of blue (M), you can guess what animal (M) I am. I am the biggest animal (M) in the world (M), as well as the biggest animal (M) that ever lived!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("If you have not guessed by now what kind of animal (M) I am, I’ll tell you. I am a blue (M) whale. I think that many of you young (M) humans (M) love (M) whales perhaps because of our behaviour and our size.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We are 30 metres long (M) – as long (M) as three buses and weigh 150 to 200 tonnes – as heavy (M) as a fully loaded wide (M) bodied aeroplane (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("However, you children (M) should remember that we will never hurt you. We love (M) humans (M). Although we never had close contact with them because of our size, we have learned to trust humans (M) when they approached us on vessels (M) to observe and photograph us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I do think that you humans (M) love (M) us and want to protect us because in the past a lot of whales (M) were shot and killed for their meat, fat or blubber and skeletons, not our species though.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("However, right whales were, humpback whales were, and minke whales still are, shot and killed. Whale fat was used as fuel before electricity was developed if you didn’t know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We are aware that Inuit people in places such as Alaska and northern Canada catch and eat (M) smaller whale species. That is their tradition, I think it’s sustainable and everyone needs to eat (M). We don’t judge the Inuit people.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Can you imagine the size of one of us? I said we are the biggest animals (M) that have ever lived. We are called rorquals because we have fins, when other whale species don’t. Whales like me also do not have teeth (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Can you guess what we have instead of teeth (M)? If you have not heard, we have long (M) plates of baleen in our mouths (M). These are made of the same material, a protein called keratin, as your skin (M), hair (M) and fingernails (M) and toenails (M). Isn’t that interesting?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("How do you think (M) we eat (M) if we do not have teeth (M)? We must dive deep and swallow a lot of water (M), in which very small crustaceans live – invertebrates – no backbone – with shells which are called exoskeletons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Despite being the largest animals (M) ever to have lived, however, all we eat (M) are tiny crustaceans called krill. We scoop up water (M) with krill swimming in it and press our tongues (M) against the baleen to strain the water (M) out. We find all the krill in the cold (M) water (M), which is rich in nutrients, around (M) the North Pole and South Pole.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As you may expect, we must swim thousands of kilometres to the tropics – the warm (M) water (M) between the Equator and the Tropic of Cancer in the Northern Hemisphere and the Tropic of Capricorn in the Southern Hemisphere – where calves are born (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Despite our size, the pregnancy of a cow whale is about a year (M). The calf is always born (M) in warm (M) water (M). We swim alone or in pairs, and usually only have one calf at a time. We could not do otherwise, could we?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I also know that whales do very good things for the environment. More plankton, in turn, increases the number (M) of small fish and the larger fish that feed on them and as you know humans (M) often eat (M) these larger fish. Since humans (M) and whales are, of course, both mammals (M), we inhale oxygen and exhale carbon dioxide.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When we surface (M), we exhale through blowholes and inhale enough oxygen to last us while we are under water (M). We have twice the amount of protein called haemoglobin in red (M) blood (M) cells to store oxygen than you do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We have more muscle protein (myoglobin) to store oxygen. However, we whales store carbon dioxide in our bodies – we are living carbon sinks. So, I hope you realise why we whales are important to the environment and why we must be protected.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, I have already told you that we whales travel up and down the latitudes of the Earth (M) (you know what latitude is – the lines drawn on a map marking south to north, whereas longitude marks east to west).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("How do you think that humans (M) keep track of us without causing themselves inconvenience? Have you heard how whales communicate? Some species use sound waves, otherwise known as echolocation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("They bounce the soundwaves off other objects, rocks, animals (M) and so forth and that is how they find their way around (M) the dark depths.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We blue (M) whales use a combination of echolocation, and you may have heard of this; we sing (M) to each other. Do you like to sing (M)? If so, you know that all kinds of human (M) singers (M) express themselves in song for various reasons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("However, the idea of you singing (M) to communicate to humans (M) in an ordinary way is far-fetched. Why would you need to do that ordinarily?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Well, the answer for us blue (M) whales is because of the very very long (M) distances between pods – sometimes 500 km – (pods are what you call groups of whales) and in the ocean (M), the pressure is higher the deeper you go.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Each whale song is different and therefore, musical phrases that we produce are very similar to your sentences and utterances in all human (M) languages (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("How then, do you think that your human (M) researchers would study us and keep track of us? They do this, apparently, by placing underwater (M) vehicles or submersibles, as they are called, fitted with microphones and other equipment that they observe using their computers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I know that you humans (M) have this technology. By studying the properties of our songs – the notes, pitches, soundwaves and so forth – cetologists can know our movements and behaviour so they can better protect us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I even know that our songs are mixed with the music of human (M) instruments to create unique music. Because we blue (M) whales (M) are obviously big and gentle, we don’t have many conflicts or predators. Of course, humans (M) used to be dangerous killers of quite a few members of our species.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When Indigo surfaced one day (M), exhaling from her blowhole, she saw a whaling vessel in the distance, but we calmly swam away. We feel protected by the efforts of researchers who look after us, do very good things for us and educate other humans (M) about us. Remember that we do good things for the environment and you humans (M). Please protect us.")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt26.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head ParaOverride-5"
  }, [_vm._v("Henry the Heron:")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello, my name is Henry, and I am a great blue (M) heron. I live in Florida with my brood on the coast (M), near a town (M) called Sarasota, which is on the west coast (M) of Florida on the Gulf of Mexico.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am one of the largest predatory birds (M) that lives on most of the continents except for Antarctica. Most of us live in tropical areas – the areas between the Tropic of Capricorn in the southern hemisphere, and the Tropic of Cancer in the northern hemisphere.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("A lot of us live in the United States, around (M) the warmer areas in the southeast, around (M) the Gulf of Mexico – around (M) the states of Texas, Louisiana, Mississippi, Alabama, Georgia, and Florida. I know that in some human (M) languages, like Polish, and I find this funny, the name ‘heron’ is used as a nickname for a tall slim man (M) or a tall slim woman (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It’s quite appropriate. We stand (M) upright because of our long (M) legs (M) and necks (M). Some of us do this in other tropical countries, especially resorts on tropical islands where humans (M) go on holidays.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The humans (M) swim in the pools and some of us stand (M) in the other end (M) of the pools and croak to the humans (M). Those of us who do this are quite tame and they like being around (M) humans (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We are tall and imposing, yet we would never hurt you. If I was to put my neck (M) on your shoulder (M), that is not a threatening gesture at all – it is our version of a hug. Male (M) and female (M) herons do this gesture all the time with each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Because we cannot use our wings (M) to show affection as they are used for flying, we put our necks (M) on each other’s backs (M). Some of my brothers (M) and sisters (M), even though we may not all be from the same brood, sometimes fly into people’s backyards and eat (M) the fish from their ponds. We get chased away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Some of us are even luckier to be occasionally fed and watered by friendly humans (M). I flew down once into a human’s (M) back (M) garden in Sarasota and tapped the glass on his back (M) door with my bill (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("He gave me a drink (M) of water (M) and some crackers which I appreciated. Some humans (M) here keep us as pets. I know they look after us and we keep their ponds and bodies of water (M) clean.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Do you know how we can swallow very big fish without injuring ourselves? Like you humans (M), we have bones (M) (vertebrae) in our necks (M). The sixth vertebrae moves out of position to allow us to swallow big fish whole. You know that birds (M) do not have teeth (M), so we need to have strong, elongated bills.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The sixth vertebra shifts and acts also like a fulcrum or a pivot. Some of you children (M) remember what a seesaw is. The vertebra is like a fulcrum on a seesaw. I’ll tell you a story about my brood and me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Did you know that with us the females (M) are the nest builders? The male (M) flies off and one at a time, brings the female (M) sticks. Gradually she builds the nest using the sticks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When we have our families, four blue (M) eggs (M) are laid in any one brood, and the female (M) sits on them to incubate them over 30 days (M). I understand that my mate is another heron (M). Some humans (M), however, pick mates of different heights to themselves. All of this is a pain in the neck (M) to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Anyway, here is an account of something that happened in my life. My mate, Elizabeth, who may or may not have been named after a tall sportswoman (M), and I, quietly raise our four chicks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We live in a mangrove near a beach, and every day (M) she and I took it in turns to catch fish, wading into the ocean (M) and spearing them with our beaks (M), swallowing them, and I know this may be off-putting to some of you, regurgitating them into the mouths (M) of our chicks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As an aside, someone told me there is a long (M)-standing Australian rock band called Regurgitator. I wonder where they got their name from! Apart from fish, adult (M) herons (M) also eat (M) mangrove worms, molluscs (for example clams), and insects.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As I have become a wise heron, I can remind you that in life, you can hardly expect everything to be, as you humans (M) say, a bed of roses. Not everything goes smoothly, and one March morning (M), in our nest – which is part of a heron colony called a rookery, a greedy crow flew up and attempted to take one of the chicks whom Elizabeth and I had just fed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So, I then sprang into action and seized him by the neck (M), holding (M) him in my beak (M). I flew from the mangroves and over the ocean (M), releasing his struggling body. He was shaken up, however, flew away. I had to protect Elizabeth and the chicks and will need to continue doing so.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Some of our cousins (M) who live nearer to where humans (M) live, such as suburbs near lagoons and bodies of water (M), sometimes as I said, have friendly relationships with humans (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("They control the fish population, keeping things sustainable. In return for this, they sometimes strut into the humans’ (M) houses (M) (we predictably think of them as nests), and are rewarded with food (M), water (M), and affection. Here is a phrase for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The reason for this is that in some human (M) cultures as far as I am aware, birds (M) are seen as nurturing, and they also fly above anxiety. They have a symbiotic relationship. This means that they both support and benefit each other. So, you learned a new term. Now you can use it in your schooling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Elizabeth and I also decided to have another chick. When the egg (M) hatched, we had to incubate it for a month (M). We both taught our chicks to fly as they became stronger, and to hunt for fish. Elizabeth and I are good parent (M) herons.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Most herons have two lots of chicks – otherwise known as broods. Unlike other herons, who choose a new mate when they have a second brood, Elizabeth and I have had contact with humans (M) when we look after their ponds, when they feed and water (M) us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Because of this, we modelled our behaviour on humans (M). Most of them are monogamous – they have one mate – as you humans (M) would say husband (M), wife (M), or partner (M). I love (M) Elizabeth and will stay her mate until we both die.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It certainly helps if people who care for us are taller than 180cm. Therefore, they too are herons and we get on well. We see eye (M) to eye (M) with these humans (M) and that is a great thing! Croak!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("There are still conflicts within our nest and within our heronry or rookery. Because of climate change, to protect against rising sea levels, there will be a sea wall built near our mangrove. When the mangrove floods, salt water (M) enters our area, our habitat, and flushes the place out.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We cannot live in a flooded area, so we all had to leave our nests and fly further up the coast (M). The sight of great blue (M) herons flying with their big blue (M) wings (M) spread out and their necks (M) moved forward is a great sight – it’s majestic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We set up new nests in mudflats further up the coast (M). Once again, I flew off to gather sticks while placing them at Elizabeth’s feet. You humans (M) might think this resembles an act of offering. I could not exactly transfer the sticks to Elizabeth’s bill, so I placed them at her feet (M), and she gradually constructed new nests.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Elizabeth is a great builder and I know my female (M) chicks will follow her. After three months (M) the chicks left the nest, however, they stayed in the area. We hope to be grandbirds eventually. The lesson here is respect your parents (M) and look after them.")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt33.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head ParaOverride-5"
  }, [_vm._v("James The Iguana")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello. I’m James. I’m an iguana and I’d like to tell you a story about my life. Being a lizard, I am not seen as cuddly. It’s true – I’m scaly and cannot control my body temperature by myself (the term ‘cold (M) blooded’ is wrong).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("However, the humans (M) who looked after my extended family and I were always kind to us. This didn’t matter if they were researchers or zookeepers. Now, you children (M) reading this may be wondering why I’m called James.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One of the researchers, Steve, who tracked and observed my family in a country called Costa Rica was an American who loved punk rock and spoke fluent Spanish. He wanted to call me Iggy after the singer Iggy Pop (use Wikipedia or YouTube to look him up). The singer’s birth (M) name is James Osterberg. So that is why I am called James.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It is unusual that I have a human (M) name, although I think some animals (M) may be given human (M) names by those humans (M) who look after them. I will tell you some more about my habitat, my family, and the problems with being an iguana. Did you ever wonder how iguanas and other reptiles (M) live? Find out in this story.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am about two metres long (M), my skin (M) is yellow (M), and I have thorny growths and scales on my body, and my family and I live in a rainforest in Central America, in Costa Rica. Costa Rica has many habitats as some of you may know.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I’m silent, as most iguanas are, but we hiss if we are threatened. Steve could speak both English and Spanish. As an intelligent iguana, I picked up on how both languages (M) sound and I can tell one from the other, even though no iguana can speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We can live at any height, so we are happy anywhere on land, pretty much. I live with my mate (you humans (M) would say wife (M), of course) Rosa and our three young (M) iguanas Pedro, Isabel, and Juan. The young (M) iguanas’ skin (M) is bright green (M), which turns paler as they grow (M) older.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I don’t know, although, it must be by choice that I was given an English name whereas my family members have Spanish names. I remember that the researcher, Steve, gave us names so he could identify us. We generally live a happy, quiet life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("During the afternoon (M), as the Sun (M) appears to gradually lower in the sky (M), we bask or sunbathe by sitting on thick, sturdy tree branches, in the canopy of the rainforest. Do you remember why we, and other reptiles, do this? That’s right. Because we cannot control our body temperature.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We must let the sunlight do this. As you know in the rainforest, it is hot (M) and humid constantly and there are downpours. When they happen, then we must descend to lower branches and wait for the storm to pass.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As you probably guessed, we can climb, swim (propelling ourselves with our big tails (M) – not like you humans (M) with your long (M) arms (M) and legs (M)).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Iguanas eat (M) pretty much everything: other animals’ (M) meat, insects (which are good snacks), and plants (M). Rosa and I have also shown the young (M) iguanas how to pick and eat (M) small fruits and leaves with our tongues (M). We never can anticipate if there are threats. However, it’s a silent life here in this rainforest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I like this life because not much happens except for when it rains. Also, you may not know this, however, in addition to both our functioning eyes (M), we have what is called a parietal eye (M) on our heads (M). It helps us keep track of light, dark and movement like a camera. Isn’t that amazing? The parietal eye (M) does not work like a seeing eye (M) does though.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Unfortunately, life does not always go according to plan. There were some local men (M) who confronted us one day (M), even though Rosa and I tried to defend ourselves by striking them with our tails (M). They took Pedro away and I think they sold him to somebody else – I think he was a rich man (M) – as a household (M) pet (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Rosa was very upset, but I understood that some humans (M) want to take members of our species as food (M). Yes, sadly, some humans (M) eat (M) our flesh as food (M). Some of us also become household (M) pets or are taken to live in zoos so we can be researched and have dedicated humans (M) look after us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It turns out that Steve the researcher – humans (M) call him a herpetologist – who researches snakes and lizards – decided to leave us in the rainforest and still track our population. Rosa and I decided to have another offspring. In a few weeks (M) Rosa laid another egg (M), and we called the offspring Antonio.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I should mention that the diet of iguanas is quite varied. Some of us eat (M) insects, some plants (M) and some eat (M) other animals’ (M) flesh.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("My family and I are of the subspecies green (M) iguana (I have great insight, do I not?) We are herbivorous – in other words we eat (M) plants (M). More specifically, leaves, shoots, and fruit, although not the roots.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Some of you reading this may remember that in some countries or markets, about ten years (M) ago there was an advertisement for bottled iced tea. One of my chameleon cousins (M) inspired the colour-changing character and we thought it was very funny.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("He talked about the differences between cold (M) black (M) tea (very bitter) and sweetened iced tea. Another threat we iguanas may have to deal with is deforestation. Luckily for us, areas of rainforest are set aside to allow us to live there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sometimes as we descend from the trees to drink (M) and swim in bodies of water (M), we must be careful of pythons and boa constrictors. You know they will strangle us to death and eat (M) us if they choose to.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One of the iguanas (M) – a female cousin (M) – was eaten (M) by a python. Luckily, none of my immediate family have been attacked or eaten (M), thanks to being focused and sensing other animals’ movement with our parietal eye (M), I hope to live in the rainforest for the rest of my 20-year life.")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt38.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head ParaOverride-5"
  }, [_vm._v("Levi the Flying Fox:")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello. I am a young (M) fruit bat called Levi, also known as a flying fox. We are found in subtropical and tropical areas of Europe, Africa, Asia, and Australia. We live in Queensland, as I’ll explain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We are 40cm long (M) with a wingspan (M) of 23cm, and a claw on our first fingers (M). We eat (M) fruit, flowers, nectar, and pollen. Interestingly, we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" peg-shaped teeth (M) and dog-like faces (M) with short (M) strong jaws (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We chew and swallow bananas, but only drink (M) the juice of ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" fruit, throwing away the pulp. We have ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" eyes (M) compared to the size of our ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("bodies.")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Our eyes (M) let in ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("more ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("light due to the rods and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" structures in the retina at the back (M) of the eye (M). We are nocturnal, sleeping in trees during the day (M) in our thousands.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Our ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("body")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" temperature stays ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("the same,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" unlike that of our insect eating (M) cousins (M). Mum (M) gave birth (M) to me ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" a six-month (M) pregnancy and carried me around (M) for ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("two ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("months (M) while I suckled from her and held onto her ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("when ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("she flew. Unfortunately, she then ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("died.")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" She was shot by an angry man (M) who thought bats were a nuisance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am looked")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" with ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" flying foxes, including my ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("two")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" foster brothers (M), whom I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("think")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of as brothers (M), by Jim, an old (M) man (M) in north Queensland (where it was hot ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("time")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" and rained half the year (M)). Jim used to be a school teacher and had always cared for animals (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Having taught biology (the branch of science about living things) to teenage boys (M) and girls (M), he thought that in retirement, he would care for orphaned flying foxes. Jim looked ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" us ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("much like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" he looked ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" his grandchildren (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("when ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("they were ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("small. Now")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that they were older, they often came ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" school to help their Grandpa (M) Jim and Grandma (M) Nora look ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Still, I missed my Mum (M). Jim and Nora cared for my brothers (M) Smoky (called that ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" he was rescued during a fire (M) of burning sugarcane stalks), Francis and I. So, Jim and Nora looked ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" us three bats.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We drank (M) milk (M) formula, ate mangoes, watched television (M), and learned to fly by following a piece of rope connecting two trees. You guessed it, the flying foxes learned to fly on a flying fox.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Jim’s 16-year-old (M) granddaughter (M), Chloe, did her best to bottle feed me so that I would grow (M) stronger to be released with my brothers (M) back into an open area, although I still would come back (M) to Jim and Nora’s house (M) for visits.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I missed my Mum (M) and clung to Chloe a lot. She didn’t mind that and thought it was sort of normal for me. She felt sorry for me and would look into my eyes (M) and stroke my furry head (M) with her thumb, thinking ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("he’s ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("dog")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" with wings (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("My brothers (M) and I would sleep (M) upside down in sacks hung from coat hangers on a wooden (M) frame which Jim’s carpenter son (M) Anthony built. We sleep (M) with our wings (M) wrapped around (M) our ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("bodies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Anthony and Nora would ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("sometimes")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" sit (M) with the bats while they watched television (M) in the evening (M). I tried to stretch my wings (M) – which were still too weak although how was I to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" and to take off towards the television (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("However, I didn’t get far at all and landed on the rug. I thought ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I want to fly. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Nora quickly picked me up, wrapped me in a T-shirt and put me on the arm (M) of her armchair (M). I twittered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I loved my owner Nora ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" she took care of me. I was the eldest of the three bats and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("wanted")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to learn to fly ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("before ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Smoky and Francis learned. Since I couldn’t talk to humans (M), sometimes I didn’t like that they couldn’t understand me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("But I ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("had")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" learned to point using ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of my wings (M), ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Nora taught me to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" so. “He’s such a smart bat,” said Nora. I could tell that my owners were being patient with me, and even though I did not understand them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Nora’s tone of voice (M) calmed me. I really ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("wanted")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to fly and flew off Nora’s shoulder (M) while she was in the kitchen, landing on top (M) of the fridge. Nora gently picked me up and put me on her shoulder (M). “I know you’re trying,” she soothed. “You’ll get there soon.” I felt better straight away and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("wanted")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to prove my owners right.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I was grateful and so were my brothers (M). I grew stronger day (M) by day (M) and I thought I would in a few weeks (M) be able to live in a tree with my brothers (M) in Jim and Nora’s backyard. I had become so attached to Jim’s family that I could never be a completely wild bat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Because we could hear very well and found our way around (M) by hearing and sound waves (echolocation), I thought that I, Smoky and Francis would always remember where Jim lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Unfortunately, I fell on Chloe’s bed one morning (M). After that, Chloe took me to her grandpa (M) and in their backyard, they both stood at opposite ends (M) of the rope that was strung between two trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Jim and Chloe both took turns to encourage me to fly ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("down")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the length of the rope. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Little")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" by ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("little,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I flew down the entire length of the rope and at last, I was a flying fox!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that, Smoky and Francis and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" flew into Jim’s mango tree and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("lived there,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" so we would always be supervised. We were happy that Jim and his family looked after us.")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt43.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head ParaOverride-5"
  }, [_vm._v("Oliver the Ostrich:")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello, I’m Oliver. I’m an ostrich with brown (M) feathers (M), or what we call plumage. The male (M) ostriches are smaller than the female (M) ostriches, who ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" black (M) and white (M) feathers (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Regardless of that, you probably ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that we are the biggest birds (M) in the whole world (M). We cannot fly ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" our sternum, or breastbone, is flat (M), ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" curved. It cannot support our chest (M) muscles (M), which would in turn support wings (M) meant for flying.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We use our short (M) and stubby wings (M) to balance ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("when ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("we run. We ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" run at speeds of between 70 and 90 kilometres per hour as fast as a car ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("down")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" a main road, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("maybe. I have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" seen many humans (M) travelling to observe and photograph us, so I")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" can ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("run as fast as they drive their vehicles. What ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" you think of that?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As you young (M) humans (M) also seem to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have very ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("long (M) legs (M) and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("very")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" long (M) necks (M). Our eyes (M) are the biggest of any animal (M) that lives on land, so every ostrich has excellent eyesight. We are as heavy (M) as a large man (M) (150kg), and as tall as a tree (2.5m), so ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" careful ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("if")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" you see us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am used to humans (M) being around (M) us ostriches, so I would not hurt you if I saw you. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I want")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to tell a story about three incidents that happened to my family and I, and how we overcame them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("My flock and I live in the Kalahari Desert. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" is a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("very big ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("desert that is in three different countries in southern Africa. The desert goes through South Africa (the ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" country right at the bottom (M) of the African continent), Botswana to the north, and Namibia to the northwest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As you would expect, it is ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("very")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" hot (M) and dry or arid. Although the Kalahari Desert is called a desert, it is a partly arid and sandy grassland or savannah. We ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" only drink (M) at oases or water (M) holes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Anyway, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I want")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to tell you")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" something ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("about my life. I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I am an ostrich (M) and I accept that I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("cannot")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" fly. I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("don’t ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("spend time wishing I could fly because imagining that would not help me. I focus on being a good father (M) bird (M), a good husband (M), and defend my chicks and the flock from predators.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("A lot of the time, I like putting my long (M) neck (M) over the backs (M) of Ophelia and Phoebe. You humans (M) may think this looks odd. However, it’s the way we ostriches (M) and other tall (M) birds (M), hug each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We cannot exactly use our wings (M) when they are used for balancing, and with most other bird (M) species, of course for flying.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One morning (M), Phoebe decided to stay on the nest looking after five of the chicks, while Ophelia and I took the other five chicks to eat (M) and drink (M). I pointed out to the chicks where the good shrubs were and where to find juicy insects. Only adults (M) could eat (M) the lizards.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Ophelia, Phoebe, and I had all decided that only the adult (M) ostriches (M) would take it in turns for safety to go to the water (M) hole to drink (M) We only allow the chicks to drink (M) from puddles and sometimes, eat (M) leaves that contain moisture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So honking, or as you humans (M) would say ‘so saying’, that afternoon (M) we were minding our business on the savannah, when suddenly we were rushed by a pack of hyenas. The flock was in danger from these terrible animals! (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("All")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I could ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" with Ophelia and Phoebe running at my ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("sides")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" was run flat (M) out ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the attacking hyenas and deliver a kick with my long (M) powerful leg (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The claws (M) on both my toes (M) of my right foot (M) pierced the fur (M) of the hyena. I then thought")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" it might die. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The pack of hyenas moved apart and left us alone. The rest of the flock was quite shaken up ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("However, the three of us did the only things we could ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" lifting our wings (M) to allow us to appear bigger than we are and kicking the attackers quite severely until they ran away and left us alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The day (M) continued, with our flock quietly drinking (M) and my honking to my ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("two")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" wives (M) and hugging them. I’m a lucky ostrich and I am ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("very")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" happy to be looking ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" a large family ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one I have.")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" It gives me responsibility which I would otherwise not have.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I love (M) taking the chicks to feed and running ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" them. I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("think I have a very ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("similar role to a human (M) father (M) feeding, teaching, and protecting my young (M). There is a reason why we are the biggest birds (M) – I see the reason as to protect the flock and defend us from any predators.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Another time, a hungry lioness ran at our flock. I thought ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("she must eat (M) something (M), but she is not going to eat (M) one of us! I ran ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" her and kicked her. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This time")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I knocked her over.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("She recovered and was ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" seriously hurt. I turned to Phoebe and honked, “Serves her right for trying to eat (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of us. She ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("eat (M) a zebra (M)!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I was once again happy to resume living as we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(". However, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" day (M) there was a threat to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of our flock. I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that in the wild, we ostriches (M) go about our business peacefully. In open range zoos, humans (M) care for us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Those humans (M) we ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("die")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" for – for our skin (M), meat, feathers (M), and eggs (M), will sometimes try to kill us in the wild even though some of us are bred on farms to be killed for this purpose.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" day (M), on the savannah, with my great eyesight I could see a vehicle driving up and a man (M) got out. He was holding (M) a long (M) tool for killing. Humans (M) call them rifles (M). I ran and kicked him in the chest (M), knocking the rifle (M) from his hands (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("He fell to the ground (M), and I scraped my foot (M) across his chest (M), tearing his clothing and breaking his skin (M) “Get out of ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("here!")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("” I honked loudly “Nobody hurts ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of my flock!”")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt48.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("How Rusty Became a")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Respectable Working Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello, I’m Rusty, I’m ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of six kelpie puppies born (M) on a farm in the state of Victoria. My Mum (M) is called Tango and my Dad (M) is called Butch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I was born (M), I had to compete with my brothers (M) and sisters (M) for Mum’s (M) milk (M) and to be kept warm (M). Weeks (M) passed ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like this,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" once I could see, of drinking (M) milk (M), sleeping, and play (M) fighting with my brothers (M) and sisters (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" red (")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("more")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the colour (M) of chocolate) fur (M) on most of my ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("body")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(", and tan fur (M) on my snout around (M) my mouth (M) and on my paws (M). Mum (M) has red (M) fur (M), Dad (M) black (M) fur (M) and two of my siblings (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" black (M) fur (M), and the rest red (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Some")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of you humans (M) may ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that dogs cannot see in colour (M) – we are colour (M) blind and only see in black (M) and white (M). Never leave us in the dark!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Anyway, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one thing")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I knew was that I was ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" going to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" a show dog, or somebody’s pet. I was going to become a working dog. Somehow, I knew, even though I could only bark, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" speak to the nice man (M) who bred me, that I had to do ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("something")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" with my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("knew")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that kelpies are dogs who work for a living herding ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("much")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" bigger animals (M). Sheep for their wool and cattle for their meat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("felt something very good")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that I can work and earn my food (M). ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" saying goodbye to Mum (M) and Dad (M), I was put into the back (M) of the breeder’s car (M) and driven to the farm ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("where")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I was going to spend the rest of my life working. My siblings (M) were also all sent to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" farms to work, and I hoped to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("see")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" them again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The new farm was ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("very big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" with ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("many")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" trees and a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("body")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of water (M) running through it, and my boss was a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("kind")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" old (M) man (M) named Frederick. I would learn what I needed to learn from Frederick, and he was patient.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I knew I would learn ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("many good things")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" from Frederick ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" he had been grazing sheep and cattle for a very long (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("time")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(". Frederick and his wife (M) Susan were an old (M) couple who I saw knew how to work with animals (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Their adult (M) sons (M) and daughters (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("lived")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" elsewhere, but ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("many times")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(", the grandchildren (M) would come and see their grandparents (M). I would let the children (M) rub my fur (M), feed me dog treats, and run with me down the dirt paths on their grandparents’ (M) farm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("was aware Fred was my boss and he owned me, but he was as ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("kind")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to me as a grandfather (M) would be to his grandchildren (M). So, I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("thought")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of him as a grandmaster.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Certainly, he was a master at what he did, grazing sheep and cattle. I am intelligent enough to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("some people think ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("of dogs and cats as children (M). I am a dog so therefore, I cannot be a human (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am very happy that Frederick and Susan, or Fred and Sue, as other humans (M) called them, looked after me with the same love (M) and care that they gave to their grandchildren (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" story is about how I became a working dog, t")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("here is")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" always a conflict in a story. For the first few weeks (M), I expected my Mum (M) to look after me. I remember that I must have been a bit lazy, because sometimes I didn’t want to do what the breeder ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("wanted me")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" so I would easily get along with other humans (M) besides him. The conflict is within me, instead of being between me and humans (M) or between me and ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" animals (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("At ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("some times,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("thought")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I would become someone’s pet. I wasn’t going to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be someone’s")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" pet ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I am a kelpie. I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("don’t see")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" any point in being spoiled and not earning my living. I would ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to describe in ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" story how Fred taught me to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" a working dog. Being a working dog is what most kelpies are born (M) for.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It would turn out that I would spend ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" my life working for Fred, Sue, and their sheep and cattle. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Here")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" is how Fred taught me to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" my work.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Fred and Sue were going to teach me over the course of a year (M) to be a working dog. I can bark, and I bark proudly that I am able to work. Work gives a dog dignity. It gives us ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("something")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(". I am proud of ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("By ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("now")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(", Fred and Sue were looking ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" me and sometimes giving me a mixture of dry food (M) and pieces of cow meat, which I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("knew")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" humans (M) call ‘beef’, if I had been an especially ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("good")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" dog.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I was ready to start looking ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Fred and Sue’s animals (M) – their livestock. They own them and care for them, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" they do for me. Only I’m smarter than their animals (M) whose wool and flesh are sold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Now, I have")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" told you that Fred was a gentle old (M) man (M) who had been a farmer for a very long (M) time. When I learned what I needed to know from him, I thought he was a very good teacher. There were a few skills, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("a few things")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I couldn’t ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" learn so I could become a working dog – an Australian sheepdog.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One day (M), Fred and his grandson (M) each sat down and picked me up, so I was looking into their eyes (M). You remember that I can only see in black (M) and white (M). They touched their noses to my nose (M). I felt something good when they did that – I was not worried.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After this,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Fred got me to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("take one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" end (M) of a long (M) thick thing (M) humans (M) call a ‘rope’ in my mouth (M) and pull it behind me while I walked down a dirt path. After I did this, Fred knelt and rubbed my fur (M). I knew I had done a good job.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("He put a chain on my collar, attaching it to a long (M) metal thing (M), one side of it in the ground (M), and had me wait for him. Because he was a good man (M), I didn’t bark and didn’t worry, I didn’t ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("feel something bad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Another")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" day (M), Sue came and put a long (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("thing")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" around (M) my collar – only ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this time")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" it was soft (M) – and walked down the path with me. Humans (M) call ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this thing")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" on my collar a lead or a leash if you speak American English! I ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("felt something good. ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I enjoyed this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("There were other dogs that worked for Fred and Sue, and while I ate dinner with them every evening (M) and was friendly with them, this story is about the dog I became, rather than focusing on them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sue had me watch the sheep and lambs. I sat there and kept an eye (M) on them. I saw that the lambs were small and that ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("bad things")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" could ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("happen")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" to them – that they were vulnerable.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When I was herding, I heard Fred and sometimes Sue, say some words or comments about what I was doing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I followed their directions because I respected them and because they were good humans (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I protected the lambs and protected my owners. Sometimes, when I was with a flock of sheep, Fred would put his arm (M) out and I would run in the opposite direction, round (M) the sheep up and bring them back (M) to him. I ran alongside the other dogs and took the sheep from one field to the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When I herded cattle, I saw they were much bigger than the sheep were, and I was afraid they would either run me over or hurt me with their horns (M)! Thankfully, nothing ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like this ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("happened and the cattle were well behaved. I am very grateful that Fred and Sue look ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" me and give me a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("good")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" job. I love (M) my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt54.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("Seville the Tomcat’s")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Incredible Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" is my story. I am Seville, a very fortunate tomcat. The man (M) who adopted me called me ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("this because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" my fur (M) is orange (M) ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the oranges grown (M) in Seville, a town in Spain. My owner is a caring man (M) called Dr Steve Jackson. Steve was a university teacher.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Perhaps ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("you don’t know")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that the ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("word")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" ‘doctor’ has ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("two")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" different meanings. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" is a verb meaning to tinker with, the other is a noun – a Latin word meaning teacher.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Docere means to teach. Steve had completed two degrees, carried out a long (M) research project and written a book about it, so he held the degree of doctor. Steve taught the science of how language (M) works – we call this linguistics. Steve was a semanticist who researched semantics – the study of meaning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am a three-year-old (M) ginger tomcat with a scratch under my left eye (M) from fighting with another cat when I was younger. The first year (M) of a cat’s life is equal to fifteen human (M) years (M), the second to nine years (M) and every year (M) thereafter to four years (M). Therefore, I am 28 human (M) years (M) old (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I am ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("one")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" of six kittens, ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" born (M) to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" given as pets. For the first two years of my life, I lived with a young (M) man (M) and woman (M) who went to university to study journalism.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Phil and his girlfriend Zoe lived in a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("small")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" apartment ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("near")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the city. Phil and Zoe played with me ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("when")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I was young (M) however, I felt that they did ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("not")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" quite give me the love (M) and attention that my mother (M) did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Granted, I jumped on the furniture, drank (M) a lot of milk (M), and ate processed food (M); however, I also went out at night (M) and got into fights with other cats and dogs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I thought I wanted contact with other cats after being separated from my mother (M) and siblings (M). Sadly, I continued to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("feel something bad")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" – I was quite upset about the separation from my mother (M) and my siblings (M). ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" upsetting situation continued for months (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("However, one day (M), Phil noticed that I was upset, not having any energy and being off my food (M). Therefore, Phil and Zoe decided to give me to Phil’s Uncle Steve – otherwise known as linguist Dr Stephen Jackson.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Dr Jackson had always loved animals (M), being the son (M) of a zoologist – a scientist who researches animals (M). ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Now")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(", I became the companion of him and his family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stephen and his family were loving and attentive to me. The family consisted of Stephen’s wife (M), Rose, who worked at home (M) writing online articles and book reviews, their son (M) Jonathan, who studied English literature at the same university his father (M) worked at, and their daughter (M) Abigail who was in Year 10 in high school.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("They lived in a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" house (M) with a backyard, with ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("many")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" trees ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("near")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" the house (M) and lining the street. Every morning (M), I would move with a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("big")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" jump off Abigail’s bed, after spending the night (M) sleeping on her doona.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Each member of the Jackson family took turns to let me sleep (M) in their bedrooms. I was a big ginger cat with what had become a quiet personality. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("A short time before ")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stephen and Rose adopted me, they knew from talking to Stephen’s nephew Phil that there were ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("many things")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" that I feared: vehicles, other aggressive cats, cucumbers, dogs, (except the neighbour’s labrador Sunny who had become very friendly with me).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I learned from Sunny to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("do good things")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" for other dogs and treat them respectfully after quite a few years (M) of being suspicious of them. This is the conflict in this story. It is not a conflict between me and any of my owners or me and any other animals (M), but between the cat I used to be and the domestic pet I became.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Before")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" continuing the story, I will ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("say more")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" about the kitten I used to be and the more mature cat I became.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I was born (M) I was just ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" any ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" kitten – my eyesight and hearing did not develop for the first two weeks (M) – all cats are ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("like this. Because")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" my mother (M) had given birth (M) to six kittens, each with different combinations of black (M), white (M), and orange (M) fur (M), they all had to compete for their mother’s (M) milk (M) and affection.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("To make (M) matters worse, I was smaller than my brothers (M) and sisters (M) and had a problem with my right front (M) paw (M) – a tight tendon was making it difficult for me to walk.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Zoe took me to the veterinarian; I was knocked out and the tendon cut and stretched so it allowed me to use the paw (M) normally after a couple of weeks (M) with a bandage around (M) it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" see that ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("because of this,")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I was a determined young (M) cat and would never give up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Even though Phil and Zoe looked ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" me, I missed my mother (M). To train my feline instincts, Phil gave me a scratching post, toys, and balls of wool to play (M) with. Zoe was a keen knitter for some reason. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One thing")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" Phil and Zoe didn’t do was allow me to play (M) with ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" cats. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(", no cat is entirely alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I would exit through the cat flap in the evening (M) and go and fight with the street cats. I became very feisty and aggressive. Ultimately, Phil and Zoe found they could not put up with this behaviour and gave me to Uncle Stephen and Aunty Rose.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("When I arrived at my new master Stephen’s house (M), I felt something very good because it was much bigger than Phil and Zoe’s apartment, with a lot more room to play (M) in and observe people.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Although I could not obviously say words or talk, I used miaows of different lengths and tones, purred, and rubbed my body and tail (M) against my owners’ legs (M) to show I was happy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I found that I was becoming a gentler and more caring cat. I knew I had to earn the right to be a good house (M) cat, rather than continue to be the aggressive half-feral cat I used to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stephen sometimes took me to the university campus ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("when")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" he was teaching the linguistics course to the first-year students. I would quietly sit (M) under Stephen’s desk, drinking (M) milk (M) from the staff fridge (Stephen always bought a litre of milk (M) especially for me), sleeping and playing with mouse toys.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("One")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" day (M), I was lucky enough to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("be")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" taken in to one of Stephen’s classes at university. Stephen got me to act as a ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("live")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" demonstrator for the Natural Semantic Metalanguage. Stephen taught them the explications – how the Natural Semantic Metalanguage explains ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("something")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" by using sentences that go from the complicated to the simple – for cats.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Stephen and the students discussed the appearance and behaviour of cats (")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("where")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" they live, how they behave around (M) people, and how they hunt mice) among other behaviours, and I liked the attention I received and was very pleased to demonstrate my behaviour. I did something good for the students – I helped teach them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I was a very grateful tomcat. My life continued happily, and I was very careful not to be hurt. Jonathan would sometimes let me fish in a local pond – I caught carp and became stronger by balancing with my paws (M) in an empty salad bowl – I thought all cats should do this exercise!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I was taken to Stephen and Rose’s neighbour and met their tuxedo cat Dominica. I got along very well with her and was protective. I knew that if kittens were born (M) I would be a protective and good father (M) cat. After some time, three kittens were born (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I stayed with them, showing them how to play and hunt, and prompting them to eat (M) and drink (M) when they were weaned off their mother’s (M) milk (M). I was an affectionate father (M), but occasionally I had to break up the kittens’ fights or disagreements. I was also gentle with Dominica, and we parented the kittens together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I never again fought with other cats or even dogs. I stayed and supervised while the kittens played with other cats and dogs. Dominica and I were the best of friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Eventually, the kittens were offered to ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("other")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" neighbours, whom Stephen and Rose ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("all")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" knew. ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After a few")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" years (M), ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("when")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" I was ten and Dominica nine (in human (M) terms 56 and 52), we became grandcats. I was caring and taught our grandkittens.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("After")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" another eight years (M), Seville and Dominica died of old (M) age and were buried in the Jacksons’ backyard. The moral of the story is that you ")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("can")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v(" overcome difficulties in life and succeed.")])]), _vm._v(" "), _c('p', {
    staticClass: "image _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035831449_txt61.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "head ParaOverride-5"
  }, [_vm._v("Tembo the Elephant")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Hello. My name is Tembo, and I am an African bull elephant. My name means ‘elephant’ in the Swahili language, which is what the humans (M) around (M) here speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Most if not all you humans (M) recognise my species and I, and how we behave, because of course we are the biggest land mammals (M) currently alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("My herd and I live on the grasslands of the Serengeti National Park in northwest Tanzania, which is a country in east Africa. I think we elephants are popular with humans (M) because we are relied on to do things like carry wood (M) and plough fields.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As you know there are two subspecies of us, the African and the Indian elephant. As you also know we the African elephants have the bigger ears (M). That is, of course, how you tell the difference. There is the bush elephant and the forest elephant.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Because we are the biggest land mammals (M), you may think we don’t have any problems or predators. We do, in fact, have our own problems. We bush elephants are the larger of the two subspecies and there are more of us – a higher population.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("It is us who the humans (M) track and research and send some of us to live in zoos so that humans (M) can see how we behave. Some of you young (M) humans (M) stereotype us, which I don’t appreciate. You know that our big ears (M) keep us cool by deflecting the heat, so our bodies remain cool and at a normal temperature.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We need that because of our body weight – the cows weigh about three tonnes, and the bulls weigh about five tonnes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Our trunks are, if you think about it, both a nose (M) and top (M) lip. We inhale water (M) and squirt it into our mouths (M), dig wells for water (M), pick up, clean, and eat (M) grass which is most of our diet, along with fruit, leaves, and tree bark. We also can warn other animals (M) of predators because our height allows us to see further.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We spend our entire day (M) feeding and moving our herd towards water (M). We have 24 teeth (M) which wear away as we grow (M) old (M) and our tusks, which are basically long (M) front (M) teeth (M). We live about 70 years (M) and have quite a few things in common with humans (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Before I get to a story about my herd and I, perhaps some of you children (M) reading this don’t exactly understand how we live in herds. Our calves are born (M) in the wet seasons and take two years (M) to grow (M) in the cows’ wombs (M). I know human (M) babies only take nine months (M) to grow (M) and develop. Like you humans (M), they take a long (M) time to develop once they are born (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You humans (M) are children (M) until about thirteen years (M) old (M), so are young (M) elephants. As you humans (M) say, “An elephant never forgets.” We have interacted with humans (M) and carried things for them, ploughed their fields and we do remember humans (M) sometimes many years (M) after first meeting them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Unfortunately, there are some calves who die, a lot like some human (M) children (M) who can die of illness. I love (M) humans (M) and I feel sorry for you when that happens. Our herd size varies, and it can be from 10 to 100. Bulls (M) mature at 26 years (M) old (M), also a lot like humans (M).")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The bulls then lead solitary lives or are in herds of up to 15. After that, the herds consist of the grandmother (M) cow, the eldest son (M) or daughter (M) and the grandchildren (M). So now you know something about how we live.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("So now, I’ll tell you a story about some incidents that happened at a time in the dry season, on our grassland in Tanzania. As I said, the calves are born (M) during the wet season. Unfortunately, my mate, Jane (I know you humans (M) say husband (M) or wife (M), but with animals (M), the equivalent is mate, if you did not know), lost a calf. As I told you some calves unfortunately, die, either after birth (M) or when they are young (M). Sadly, this calf was premature and could not survive. It was sad for us, and we grieved over him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("At the same time, we accept that some of our calves die. It’s part of being an elephant although with zoologists and veterinarians looking after us, the causes of some of our calves being prematurely born (M) can be looked at and I think sometimes the condition of the cow has a lot to do with it. We buried the calf and immediately, we decided to have another calf.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("You remember that elephant pregnancies take around (M) two years (M). The entire herd hoped that this new calf would be a good replacement for the one who had died. We have five calves in our herd, so everyone noticed that calf who had unexpectedly died. We knew we’d overcome this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("The whole herd did. In general, we elephants have a good life, with dust baths, drinking (M) from bodies of water (M) such as lakes and streams, and eating (M) grass, fruits, and leaves. As you would also expect, we do a lot of walking, from morning (M) to evening (M), towards water (M) holes. You would not expect us to be standing around (M), would you?")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("We’re too heavy to do that. Maybe my herd and I can set an example. Our feet have fleshy pads inside them to support our weight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sometimes, humans (M) come and visit (M) the national park to see us and take photographs. Some of the calves in the park’s larger population – which can number (M) a hundred to a thousand (the entire herd, that is, not just my family) – run at the vehicles. I think they are just as curious to see what the humans (M) do as the humans (M) are about us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Jane and I have had to turn calves around (M) before they have had a chance to charge at the vehicles. The only humans (M) I will allow us near are researchers, some locals who look after us and train the calves, and some of our herd live in zoos so they can be studied, looked after, and appreciated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I’m trying to remind you that humans (M) and elephants have a few things in common. You can guess what they are – families and long (M) memories (one of my Asian cousins (M) knows that the ginkgo biloba tree gives its fruit to be processed and that is what you humans (M) take to strengthen your memory). Don’t ask me how I know this, however, remember that an elephant does not forget.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Sometimes, I must break up fights between our five calves, give them love (M) and affection and teach them how to be elephants. Every baby, human (M), elephant or otherwise, is born (M) with a brain that allows them to learn. I believe you humans (M) say the brains are wired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("I had to teach the calves to drink (M) and to dig wells in the dirt to find more water (M). We know which plants (M) to look for and teach the calves to snap off and eat (M) the branches and fruit.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("As you would expect, we see many other animals (M) in the Serengeti, such as water (M) buffalo, gazelles, impala, and zebras.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Most of the time, we drink (M) with them at water (M) holes, and we are respectful of them. However, I think we as a species are more intelligent than water (M) buffalo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Our only enemies are the lionesses and the hyenas. Normally, we can charge at them and deter them. The hyenas, horrible animals (M), occasionally do the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Unfortunately, some of the herd’s calves were eaten by lionesses Once again, I realised that everyone must eat (M). The calves who were eaten were too slow to escape, and now, Jane and I deter the lionesses away from our herd and consequently, they eat (M) zebras (M) or water (M) buffaloes instead. Our herd is safe.")])]), _vm._v(" "), _c('p', {
    staticClass: "the-end"
  }, [_vm._v("THE END")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b5524f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EPUB.vue
// module id = 57
// module chunks = 0